import Hero from '../assets/hero.jpg';
import {Link} from 'react-router-dom';
export const Home = () => {
  return (
    <>
    
    <section className="text-gray-600 body-font text-center">

    <img alt="hero" className="w-full object-cover object-center rounded-lg h-96" src={Hero} />

    <h1 className="text-4xl font-medium py-4">Welcome to FlowRun – Your Personal Running Companion!</h1>
    <p className=''>Whether you're a seasoned marathoner or just starting your running journey, [App Name] is here to help you track, improve, and celebrate your progress.
    <br /><br />
🚀 <b>What We Offer:</b>

<br />🏃‍♂️ Calculate Your Running Pace: Find out how fast you're running with our easy-to-use pace calculator.

<br /> 🔥 Estimate Calories Burned: See how many calories you've torched during your run.

<br />📊 Track Your Progress: Log your runs and watch your fitness improve over time.

<br /><br />💡 <b>How It Works:</b>

<br />Enter your run details: distance, time, and weight.

<br />Get instant insights into your pace and calories burned.

<br />Use the data to set goals and crush them!

🌟 <br /><br />
<b>Why Choose FlowRun?</b>
<br />
    Simple, intuitive, and designed for runners of all levels.
    <br />
    No complicated setups – just accurate results in seconds.
    <br />
    Your personal tool for smarter, more efficient running.
    <br />
Ready to take your running to the next level? Let’s get started!
<br />
👉 Tap Below to Calculate Your Pace and Calories Burned
Key Elements:

    <br /><br />
   
 </p>

 <p> <Link to="/calculation" className="rounded-lg bg-red-600 px-4 p-2 my-4 text-white">Calculate Your Pace</Link>    </p>
    
    </section>
    
    </>
  )
}
